import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { Spinner } from '@/components/ui';
import { useAuth } from './AuthProvider';

import styles from './ProtectedRoute.module.css';

/** Shown while the initial `account.get()` decides which screen the user gets. */
export function Splash({ label = 'Restoring your session…' }: { label?: string }) {
  return (
    <div className={styles.splash}>
      <img className={styles.mark} src="/ela-logo.svg" alt="ELA Lab" />
      <Spinner size="sm" />
      <span className={styles.label}>{label}</span>
    </div>
  );
}

/**
 * The web counterpart of `AuthGate`: unknown → splash, unauthenticated →
 * sign-in, authenticated → the requested route.
 *
 * Authorisation itself is not enforced here — it is enforced by Appwrite's
 * row-level permissions and by every query being scoped to the signed-in
 * user's own `user_id`. This guard only decides what to render.
 */
export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'unknown') return <Splash />;

  if (status === 'unauthenticated') {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
